import { SDLUtil, RequestUtil, StringUtil } from '@/utils';

const setJumpHostStatusData = ({ commit }, data) => {
  commit('SET_JUMP_HOST_STATUS_DATA', data);
};

export default {
  async SEARCH_JUMP_HOST_STATUS_DATA(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/rem/jumpHostStatus/selectJumpHostStatusList?${StringUtil.queryStringfy(param)}`);
    setJumpHostStatusData(store, data.data);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/rem/jumpHostStatus/jumpHostStatusAction.js